<template>
    <div class="loader">
        <img src="@/assets/Precomp2.gif" alt="" />
    </div>
</template>
<script>
export default {
    name: "Invite",

    data() {
        return {
            invited_array: [],
            enteredEmail: "",
            colored: false,
            activeHeightAuto: false,
            invited: {},
            alreadyInvited: false,
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.loader {
    margin-top: 8%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    img {
        height: 400px;
    }
    @media only screen and (max-width: 640px) {
        margin-top: 20%;
    }
}
</style>
